// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"e7b68bea","191":"cecbbb61","209":"547ba417","378":"bdc5ae7c","491":"6baef148","603":"1acdea93","973":"44508ed3"}[chunkId] + ".chunk.js";
};